import { Fit } from "@seneca/image-service-client";

import { transformCdnImageUrl } from "seneca-common/utils/images";

import { AssetParameters } from "../../types";
import { ContentSource } from "../types";

export function getModuleAssets(source: ContentSource): Array<string> {
  return [source.image.src];
}

const makeImageAssetParams = (
  height: number,
  width: number
): AssetParameters => ({
  height,
  width,
  // @ts-ignore
  fit: Fit.FILL
});

export function transformModuleAssets(source: ContentSource): ContentSource {
  const { height, width } = source.image;
  const params = makeImageAssetParams(height, width);

  return {
    ...source,
    image: {
      ...source.image,
      src: transformCdnImageUrl(source.image.src, params)!
    }
  };
}
